import React from 'react';
import { useSelector } from 'react-redux';

import { CacheControl } from '@swf/components/ResponseHeaders/ResponseHeaders';
import { select } from '@swf/core/store';
import type { StaticContext } from '@swf/core/types/StaticContext';

const FirstRoute: React.FC<{
  component: React.ComponentType;
  staticContext: StaticContext;
  noCache?: boolean;
}> = ({ component, staticContext = {}, noCache }) => {
  const origin = useSelector(select.location.getOrigin);
  const href = origin + '/';
  staticContext.prefetch = ({ dispatch }, options) => dispatch.page.fetchPage({ ...options, href });

  return (
    <>
      {noCache && <CacheControl>no-cache</CacheControl>}
      {React.createElement(component)}
    </>
  );
};

export default FirstRoute;
